import { Route } from 'types/route.type';
import ControlsScreen from 'views/playground/features/data-lab/components/screens/controls-screen';
import DrillDownScreen from 'views/playground/features/data-lab/components/screens/drill-down-screen';
import EmbeddedScreen from 'views/playground/features/data-lab/components/screens/embedded-screen';
import FlowScreen from 'views/playground/features/data-lab/components/screens/flow-screen';
import OverviewScreen from 'views/playground/features/data-lab/components/screens/overview-screen';
import GalleryScreen from 'views/playground/features/data-lab/components/screens/gallery-screen';

// Each screen has its own exact route. Add an entry when its screen is ready.
export const routes: Route[] = [
  {
    path: '/playground/data-lab',
    component: OverviewScreen,
  },
  {
    path: '/playground/data-lab/gallery',
    component: GalleryScreen,
  },
  {
    path: '/playground/data-lab/drill-down',
    component: DrillDownScreen,
  },
  {
    path: '/playground/data-lab/flow',
    component: FlowScreen,
  },
  {
    path: '/playground/data-lab/embedded',
    component: EmbeddedScreen,
  },
  {
    path: '/playground/data-lab/controls',
    component: ControlsScreen,
  },
];
